import { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { toast } from "sonner";
import { CheckCircle2, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Logo } from "@/components/Logo";
import api from "@/lib/api";
import { formatMoney } from "@/lib/utils";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const session_id = params.get("session_id");
  const payLink = params.get("pay");
  const [status, setStatus] = useState(null);
  const [tries, setTries] = useState(0);

  useEffect(() => {
    if (!session_id) return;
    let mounted = true;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${session_id}`);
        if (!mounted) return;
        setStatus(data);
        if (data.status !== "PAID" && tries < 10) {
          setTimeout(() => setTries((t) => t + 1), 1500);
        }
      } catch { setStatus({ status: "ERROR" }); }
    };
    poll();
    return () => { mounted = false; };
  }, [session_id, tries]);

  return (
    <div className="stream-dark min-h-screen flex items-center justify-center px-4">
      <div className="w-full max-w-md text-center">
        <Link to={payLink ? `/pay/${payLink}` : "/"} className="flex justify-center mb-8"><Logo light /></Link>
        <div className="card-dark p-10">
          {status?.status === "PAID" ? (
            <>
              <CheckCircle2 size={72} className="mx-auto text-[#22C55E] mb-6" />
              <h1 className="font-heading font-black text-3xl text-white mb-2">Plaćanje uspješno!</h1>
              <p className="text-white/60 mb-2">Iznos: <span className="text-white font-bold">{formatMoney(status.amount)} {status.currency}</span></p>
              <p className="text-white/40 text-xs break-all mt-3" data-testid="pay-session-id">{session_id}</p>
            </>
          ) : (
            <>
              <div className="animate-spin mx-auto w-12 h-12 border-4 border-[#FFD60A] border-t-transparent rounded-full mb-6"></div>
              <h1 className="font-heading font-black text-2xl text-white mb-2">Potvrđujemo plaćanje…</h1>
              <p className="text-white/60 text-sm">Molimo pričekajte trenutak.</p>
            </>
          )}
          <Link to={payLink ? `/pay/${payLink}` : "/dashboard"}><Button className="btn-yellow rounded-full px-8 mt-8" data-testid="back-to-dashboard">{payLink ? "Nazad na uplatni link" : "Nazad na dashboard"}</Button></Link>
        </div>
      </div>
    </div>
  );
}

export function PaymentCancel() {
  return (
    <div className="stream-dark min-h-screen flex items-center justify-center px-4">
      <div className="w-full max-w-md text-center">
        <Link to="/" className="flex justify-center mb-8"><Logo light /></Link>
        <div className="card-dark p-10">
          <XCircle size={72} className="mx-auto text-[#EF4444] mb-6" />
          <h1 className="font-heading font-black text-3xl text-white mb-2">Plaćanje otkazano</h1>
          <p className="text-white/60">Vaše plaćanje nije dovršeno.</p>
          <Link to="/dashboard"><Button className="btn-yellow rounded-full px-8 mt-8" data-testid="cancel-back">Nazad na dashboard</Button></Link>
        </div>
      </div>
    </div>
  );
}
